import React, { memo } from 'react';
import { Carousel, Flex } from 'antd-mobile';
import { FrameWork } from 'pubBiz';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './index.modules.less';

const { Shape } = FrameWork;

const defaultProps = {
  containerStyle: {},
  loadEnd: false,
  data: [],
  onPress: null
};

const dataPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string, // id
    title: PropTypes.string // 标题
  })
);

const propTypes = {
  containerStyle: PropTypes.object, // 样式
  width: PropTypes.any.isRequired, // 宽度
  height: PropTypes.any.isRequired, // 高度
  loadEnd: PropTypes.bool, // 是否加载完成
  data: dataPropTypes, // 数据
  onPress: PropTypes.func // 点击事件
};

const ArticleCell = memo((props) => {
  const {
    containerStyle, // Object 样式
    width, // Any 宽度
    height, // Any 高度
    loadEnd, // Boolean 是否加载完成
    data, // Array 数据
    onPress, // Function 点击事件
    onMorePress // Function 查看更多点击事件
  } = props;

  // 渲染成员项
  const renderItem = (item, index) => {
    const {
      id, // String id
      title // String 标题
    } = item;
    return (
      <div
        key={`article-cell-${index}`}
        className={styles.articleItem}
        onClick={() => {
          onPress && onPress(item);
          window.app.routerGoTo(`/shop/home/news/${id}`);
        }}>
        {title}
      </div>
    );
  };

  if (loadEnd && (!data || !data.length)) return null;

  if (!loadEnd) {
    return (
      <Flex className={styles.articleCellContainer} style={containerStyle}>
        <Shape type="square" w="100%" h="0.64rem" />
      </Flex>
    );
  }

  return (
    <Flex className={styles.articleCellContainer} style={containerStyle}>
      <Flex align="center" justify="center" className={styles.newsTitle}>
        <span>享资讯</span>
      </Flex>
      <Flex direction="row" justify="between" className={styles.newsContent}>
        <Carousel
          vertical
          autoplay
          infinite
          autoplayInterval={3000}
          dots={false}
          dragging={false}
          swiping={false}
          style={{ width, height }}>
          {data.map((item, index) => renderItem(item, index))}
        </Carousel>
        <Flex
          direction="row"
          align="center"
          justify="center"
          onClick={() => {
            onMorePress && onMorePress();
            window.app.routerGoTo('/shop/home/news');
          }}>
          <div className={styles.newsMore}>
            <span>更多</span>
          </div>
          <i className={cx('iconfont', 'icon-arrow-right', styles.icon)} />
        </Flex>
      </Flex>
    </Flex>
  );
});

ArticleCell.defaultProps = defaultProps;
ArticleCell.propTypes = propTypes;

export default ArticleCell;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/ArticleCell/index.js